(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-handball/views/init-box/init.js') >= 0) return;  svs.modules.push('/components/themes/sport-handball/views/init-box/init.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.themes=_svs.themes||{};
_svs.themes.sport_handball=_svs.themes.sport_handball||{};
_svs.themes.sport_handball.templates=_svs.themes.sport_handball.templates||{};
svs.themes.sport_handball.templates.init = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
Handlebars.partials['components-themes-sport_handball-init'] = svs.themes.sport_handball.templates.init;
})(svs, Handlebars);

 })(window);